import { Col, Row, Spin, Tabs } from 'antd';
import qs from 'qs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import MyEnterpriseDetailComponent from '../../components/enterprises/MyEnterpriseDetailComponent';
import { RootState } from '../../modules';
import { getLoggedInUserAsync, getMyEnterpriseAsync } from '../../modules/auth';
import MyEnterpriseUserListContainer from './MyEnterpriseUserListContainer';
import MyEnterpriseConfigContainer from './MyEnterpriseConfigContainer';
import Title from 'antd/lib/typography/Title';
import FinancialAssetContainer from '../financial-asset/FinancialAssetContainer';
import { defineAbilityFor } from '../../util/appAbilityService';

const { TabPane } = Tabs;

interface MyEnterpriseDetailContainerProps {
  enterpriseId: string;
}

function MyEnterpriseDetailContainer({
  match,
  history,
}: RouteComponentProps<MyEnterpriseDetailContainerProps>) {
  const { enterpriseId } = match.params;

  const { tab } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  const dispatch = useDispatch();

  const [mount, setMount] = useState(true);
  const [ability, setAbility] = useState<any>();
  const user = useSelector((state: RootState) => state.auth.auth.data);

  useEffect(() => {
    dispatch(getMyEnterpriseAsync.request(enterpriseId));
  }, [dispatch, enterpriseId]);

  useEffect(() => {
    if (!mount) return;
    if (user === null) {
      dispatch(getLoggedInUserAsync.request(null));
    } else {
      setAbility(defineAbilityFor(user));
    }
    return () => setMount(false);
  }, [user, dispatch, mount]);

  const { data, loading, error } = useSelector(
    (state: RootState) => state.auth.myEnterprise,
  );

  const moveToEnterpriseEditPage = () => {
    history.push('myEnterprise/edit');
  };

  // const moveToProfilePage = () => {
  //   history.push(`profile?reqConnectModusign=true`);
  // };

  return (
    <>
      {loading && <Spin />}
      {error && <p style={{ textAlign: 'center' }}>에러 발생!</p>}
      {data && (
        <>
          <Row>
            <Col>
              <Title level={4}>내 회사</Title>
            </Col>
          </Row>

          <Tabs defaultActiveKey={tab as string} destroyInactiveTabPane>
            <TabPane tab="기본정보" key="1">
              <MyEnterpriseDetailComponent
                myEnterprise={data}
                moveToEnterpriseEditPage={moveToEnterpriseEditPage}
              />
            </TabPane>
            <TabPane tab="직원관리" key="2">
              <MyEnterpriseUserListContainer enterpriseId={enterpriseId} />
            </TabPane>
            {!!ability && ability.can('update', 'EnterpriseRole') && (
              <TabPane tab="카드관리" key="3">
                <FinancialAssetContainer
                  enterpriseId={enterpriseId}
                  isMyAsset={false}
                />
              </TabPane>
            )}
            {!!ability && ability.can('update', 'EnterpriseRole') && (
              <TabPane tab="설정" key="4">
                <MyEnterpriseConfigContainer enterpriseId={enterpriseId} />
              </TabPane>
            )}
            {/* <TabPane tab="계약서 양식" key="3">
              <ModusignTemplateListContainer
                moveToProfilePage={moveToProfilePage}
              />
            </TabPane> */}
          </Tabs>
        </>
      )}
    </>
  );
}

export default MyEnterpriseDetailContainer;
